import * as React from 'react';
import { translate } from 'PyzShopUi/scripts/utils/translate';

export interface IHeaderContainerProps {
    cssClass?: string;
    headingText?: string;
    selectedValue?: string;
    children: React.ReactNode;
}

export const HeaderContainer: React.FunctionComponent<IHeaderContainerProps> = props => (
    <div className="filter-section">
        <div className={props.cssClass}>
            <div className="product-configuration-header">
                <span className="heading4">{translate(props.headingText, 'article-detail')} - </span><i>{props.selectedValue}</i>
            </div>
            {props.children}
        </div>
    </div>)
